import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { CircularGaugeComponent } from '@syncfusion/ej2-angular-circulargauge';
import { Subject, combineLatest, takeUntil, distinctUntilChanged, filter } from 'rxjs';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { Organisation, OrganisationDashboard } from '@services/organisation-data.service';

@Component({
	selector: 'app-dashboard-shortcut',
	templateUrl: './dashboard-shortcut.component.html',
	styleUrls: ['./dashboard-shortcut.component.scss']
})
export class DashboardShortcutComponent {

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** panelData */
	@Input() panelData: any;

	/** publicPanelData */
	@Input() publicPanelData: PanelData[];

	/** refresh */
	@Input() refresh: boolean;

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** gauge */
	@ViewChild('gauge') gauge!: CircularGaugeComponent;

	/** buttonClicked */
	@Output() buttonClicked = new EventEmitter<OrganisationDashboard>();

	constructor(
		public globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef
	) {
		/** Get required subscriptions */
		combineLatest([
			this.siteSubscriptions.selectedOrganisation$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([selectedAccount]) => !!selectedAccount)
		).subscribe({
			next: ([selectedAccount]) => {
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});
	}

	/**
	 * buttonClick
	 */
	buttonClick(organisationDashboard: OrganisationDashboard) {
		this.buttonClicked.emit(organisationDashboard);
	}
}
